import { useStorePagination } from '@centric-os/stores/plugins/pagination';
import { SiteStatus } from '@centric-os/types';
import { debounce, isEmpty, isNil } from 'lodash-es';
import type { Store } from 'pinia';
import { computed, ref } from 'vue';

export default (store: Store) => {
  const { queryParams } = useStorePagination(store);

  const debounceStringSetting = debounce((value: string, field: string) => {
    queryParams.value.page = 1;
    if (isNil(value) || isEmpty(value)) {
      delete queryParams.value[field];
    } else {
      queryParams.value[field] = value;
    }
  }, 500);

  const globalFilter = computed<string>({
    get() {
      return queryParams.value?.filter;
    },
    set(value: string) {
      debounceStringSetting(value, 'filter');
    },
  });

  const statusFilter = computed<SiteStatus>({
    get() {
      return queryParams.value?.status ?? SiteStatus.ACTIVE;
    },
    set(value: SiteStatus) {
      queryParams.value.page = 1;
      queryParams.value.status = value;
    },
  });

  const filters = ref({
    globalFilter: {
      value: null,
    },
  });

  return {
    filters,
    globalFilter,
    statusFilter,
  };
};
